import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  activeStep: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
};

const Title = ({ children, className, activeStep }) => {
  const classes = classNames({
    'create-wizard-step-header': true,
    [className]: !!className,
  });

  if (!activeStep?.title) {
    return null;
  }

  return (
    <div className={classes}>
      {activeStep.icon && (
        <span className="create-wizard-step-icon">
          <img src={getAsset(activeStep.icon)} alt="" />
        </span>
      )}
      {activeStep.title && (
        <h2 className="create-wizard-step-title">{activeStep.title}</h2>
      )}
      {activeStep.subtitle && (
        <>
          {typeof activeStep.subtitle === 'function' ? (
            <div className="create-wizard-step-subtitle">
              {activeStep.subtitle()}
            </div>
          ) : (
            <p className="create-wizard-step-subtitle">{activeStep.subtitle}</p>
          )}
        </>
      )}

      {children}
    </div>
  );
};

Title.propTypes = propTypes;

export default Title;
